import { ADD_ALERT } from '@instructure/quiz-common';
import { removeAlert } from '../actions/alerts';
var alertTimerMiddleware = function alertTimerMiddleware(store) {
  return function (next) {
    return function (action) {
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : setTimeout;
      if (action && action.type === ADD_ALERT && action.payload.removeIn && action.payload.variant != 'stickyerror') {
        var remove = function remove() {
          store.dispatch(removeAlert(action.payload.uuid));
        };

        // injected for testing
        delay(remove, action.payload.removeIn);
      }
      return next(action);
    };
  };
};
export default alertTimerMiddleware;